module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-demo test",
    attrs: {
      "theme": "dark",
      "mode": "horizontal"
    }
  }, [_c('span', [_vm._v("运动世界校园")]), _vm._v(" "), _c('el-dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    on: {
      "command": _vm.loginOut
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.user.name) + ",欢迎您\n\t\t\t\t"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    on: {
      "command": _vm.loginOut
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_vm._v("退出登录")])], 1)], 1), _vm._v(" "), (_vm.$util.isComplexVersion) ? [_c('el-menu-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    attrs: {
      "index": "2"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/yunying'
    }
  }, [_vm._v("运营管理")])], 1), _vm._v(" "), _c('el-menu-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    attrs: {
      "index": "1"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/xiaoyuan'
    }
  }, [_vm._v("校园管理")])], 1), _vm._v(" "), _c('el-menu-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    attrs: {
      "index": "3"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/user'
    }
  }, [_vm._v("用户管理")])], 1), _vm._v(" "), _c('el-menu-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    attrs: {
      "index": "4"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/secretary'
    }
  }, [_vm._v("小秘书")])], 1)] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d6c4814a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Top.vue
// module id = 1131
// module chunks = 0